import {
  CheckroomOutlined as FittingRoomIcon,
  Domain,
  Groups,
  StoreMallDirectory,
} from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";

import { SidebarItem } from "@/components/layout/Sidebar/SidebarItem";
import { SidebarSection } from "@/components/layout/Sidebar/SidebarSection";
import { paths } from "@/routes/paths";
import { UserRole } from "@/utils/roleManager";

interface StoreViewSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  userHasPermission: (role: UserRole) => boolean;
  isMobile?: boolean;
  onItemSelect?: () => void;
}

export const StoreViewSection: React.FC<StoreViewSectionProps> = ({
  isExpanded,
  onToggle,
  userHasPermission,
  isMobile = false,
  onItemSelect,
}) => {
  const { t } = useTranslation();

  const canSeeStoreView = [UserRole.ASSOCIATE, UserRole.STORE_ADMIN].some((role) =>
    userHasPermission(role),
  );

  if (!canSeeStoreView) {
    return null;
  }

  return (
    <SidebarSection
      title={t("nav.sections.storeView")}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isMobile={isMobile}
    >
      <SidebarItem
        label={t("storeInsights.storePerformance.title")}
        path={paths.storeInsights.performance}
        icon={<StoreMallDirectory />}
        minimumRole={UserRole.STORE_ADMIN}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        afterSelect={onItemSelect}
      />

      <SidebarItem
        label={t("storeComparison.title")}
        path={paths.storeInsights.comparison}
        icon={<Domain />}
        minimumRole={UserRole.CUSTOMER_ADMIN}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        afterSelect={onItemSelect}
      />

      <SidebarItem
        label={t("layout.sidebar.storeViewSection.groupComparison")}
        path={paths.storeInsights.groupComparison}
        icon={<Groups />}
        minimumRole={UserRole.CUSTOMER_ADMIN}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        afterSelect={onItemSelect}
      />

      <SidebarItem
        label={t("nav.fittingRoomsLiveView")}
        icon={<FittingRoomIcon />}
        minimumRole={UserRole.ASSOCIATE}
        userHasPermission={userHasPermission}
        isMobile={isMobile}
        path={paths.storeInsights.fittingRoomsLiveView}
        afterSelect={onItemSelect}
      />

      {/*<SidebarItem*/}
      {/*  label={'Comparison Analytics'}*/}
      {/*  path="/admin/experimental/comparison-analytics"*/}
      {/*  icon={<CompareIconNew/>}*/}
      {/*  minimumRole={UserRole.STORE_ADMIN}*/}
      {/*  userHasPermission={userHasPermission}*/}
      {/*  isMobile={isMobile}*/}
      {/*/>*/}
    </SidebarSection>
  );
};
